//#region Styles
import { Container } from "./styles";
//#endregion
//#region Utils
import { 
    getText as getTextTime,
    getTimeParts as getTimePartsTime 
} from "components/CustomTimePicker/utils";
import { getDatePartsByMillis, MONTHS, WEEK_DAYS } from "components/CustomDatePicker/utils/helpers";
//#endregion

const getTextTimeByMinutes = (timeMinutes) => {
    return getTextTime(getTimePartsTime(timeMinutes));
}

export const DurationDataRender = ({
    duration 
}) => {
    const getDate = () => {
        const [year, monthIdx, dateNumber] = getDatePartsByMillis(duration.date);
        const day = WEEK_DAYS[new Date(duration.date).getDay()];
        return `${day}, ${dateNumber} de ${MONTHS[monthIdx]} ${year}`;
    }
    const getTime = () => {
        const { start, end } = duration.time;
        const startString = getTextTimeByMinutes(start);
        const endString = getTextTimeByMinutes(end);
        return `${startString} - ${endString}`;
    }
    return (
        <Container>
            <div>
                <strong>Fecha: </strong>
                {getDate()}
            </div>
            <div>
                <strong>Hora: </strong>
                <span>{getTime()}</span>
            </div>
        </Container>
    );
}

export default DurationDataRender;